module.exports = __webpack_public_path__ + "img/trofeu_b.595b166f.png";